// @flow
import React, { lazy } from 'react'
import { PrivateRoute } from 'src/common/components'

const AdminManagementPage = lazy(() => import('src/modules/adminManagement/AdminManagementPage'))

export default [
  <PrivateRoute exact={true} path="/admin-management" component={AdminManagementPage} key="admin-management"/>,
]
